const einProgram = {
  einProgram: {
    pageHeader: 'Clientes potenciales y Red de Instaladores de Enphase',
    title: 'Membresía de EIN aceptada',
    overview: 'Sistema',
    noCompany: 'No se encontró compañía',
    goToDashboard: 'Ir a Panel',
    messageFromCeo: 'Lee el mensaje de nuestro Director General',
    companyProfileLink: 'Actualiza tu perfil de la compañía',
    serviceAreasLink: 'Selecciona tus áreas de servicio',
    leadsPreferencesLink: 'Configura tus preferencias de clientes potenciales',
    reviewInstallerLink: 'Revisa los T&C del instalador',
    open: 'abierto',
    video: 'video',
    selected: 'seleccionado',
    learnMore: 'Más información',
    completed: 'Completado',
    pending: 'Pendiente',
    optInDisabledHeader: 'Programa EIN (Próximamente)',
    optInDisabledDescription:
      '¡La Red de Instaladores de Enphase (EIN) es una gran manera de que los propietarios de vivienda te encuentren! Los propietarios de vivienda dependen de EIN para identificar los instaladores que ofrecen los estándares más altos de atención al cliente y calidad del sistema usando productos de Enphase. Como miembro de EIN, puedes disfrutar de muchos beneficios que te ayudarán a vender más, instalar más y generar más.',
    einTier: 'Tu nivel de Red de Instaladores de Enphase (EIN): ',
    none: 'Ninguno',
    viewBenefits: 'Para visualizar tus beneficios de EIN, haz clic ',
    here: 'aquí',
    anyQuestions: ' Si tienes alguna pregunta con respecto a tu membresía de EIN, ponte en contacto con tu',
    enphaseAccountRepresentative: ' representante de cuentas de Enphase.',
    learnReceivingLeads:
      'Obtén información sobre cómo recibirás clientes potenciales desde la plataforma digital de Enphase ',
    benefitsOfEIN: 'Visualizar los beneficios de EIN ',
    contactEnphaseRepresentative:
      '. Ponte en contacto con tu representante de cuentas de Enphase para obtener más información acerca de EIN y el Programa de Clientes Potenciales de Enphase.',
    congratulations: '¡Felicidades!',
    whichInstaller: '%{tierName} Instalador. ',
    invitationText1: 'Has sido invitado a participar de la Red de Instaladores de Enphase (EIN) como ',
    invitationText2:
      'La Red de Instaladores de Enphase (EIN) es nuestra red confiable de instaladores que ofrecen una experiencia excepcional a propietarios de vivienda usando productos de Enphase. La EIN está diseñada para fortalecer nuestra relación contigo y acelerar tu crecimiento. Como miembro de EIN, puedes disfrutar de muchos beneficios que te ayudarán a vender más, instalar más y generar más. Revisa los beneficios completos ',
    acceptInvitation: 'Para aceptar tu invitación:',
    acceptTerms: 'Acepto los Términos y Condiciones',
    cellmodemCheck: 'Acepto los',
    cellmodemTeamcondition: ' Términos y Condiciones ',
    cellmodemLinkTitle: 'de Extensión de datos de Mobile Connect',
    notEstablished: 'No establecido.',
    contactEin:
      'Ponte en contacto con tu representante de cuentas de Enphase para obtener más información acerca de EIN.',
    getFreeLeads: 'Para obtener clientes potenciales gratis, completa los siguientes pasos:'
  }
};

export default einProgram;
